import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import AddressField from 'Parts/ui/components/fields/AddressField';
import UnitField from 'Parts/ui/components/fields/UnitField';
import CityField from 'Parts/ui/components/fields/CityField';
import ProvinceField from 'Parts/ui/components/fields/ProvinceField';

class InformationFields extends Component {
  render() {
    const { organization } = this.props;

    return (
      <Fragment>
        <AddressField
          className="TransactionsPageForm__Field"
          form={this.props.form}
          label={true}
          placeholder={false}
          required={true}
          initialValue={this.props.savedValues.address || undefined}
          identity={organization ? 'company' : 'user'}
        />
        <UnitField
          className="TransactionsPageForm__Field"
          form={this.props.form}
          label={true}
          placeholder={false}
          initialValue={this.props.savedValues.unit || undefined}
          identity={organization ? 'company' : 'user'}
        />
        <CityField
          className="TransactionsPageForm__Field"
          form={this.props.form}
          label={true}
          placeholder={false}
          required={true}
          initialValue={this.props.savedValues.city || undefined}
          identity={organization ? 'company' : 'user'}
        />
        <ProvinceField
          className="TransactionsPageForm__Field"
          form={this.props.form}
          provinces={this.props.provinces}
          locale={this.props.locale}
          label={true}
          placeholder={true}
          required={true}
          initialValue={this.props.savedValues.province || undefined}
          identity={organization ? 'company' : 'user'}
        />
      </Fragment>
    );
  }
}

InformationFields.defaultProps = {
  organization: false,
  savedValues: {}
};

InformationFields.propTypes = {
  form: PropTypes.object.isRequired,
  provinces: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  organization: PropTypes.bool,
  savedValues: PropTypes.object
};

export default InformationFields;
